// GetFilters returns the filter sections which should be shown for the current category and applied filters
export const CategoryFiltersService_GetFiltersLazy = () =>
  import("./service.grpc").then((m) => m.CategoryFiltersService_GetFilters);
CategoryFiltersService_GetFiltersLazy.method =
  "aysa_api.services.category_page.v1.filters.CategoryFiltersService/GetFilters" as const;

// GetQuestionnaire returns the full form of the questionnaire.
export const CategoryFiltersService_GetQuestionnaireLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryFiltersService_GetQuestionnaire
  );
CategoryFiltersService_GetQuestionnaireLazy.method =
  "aysa_api.services.category_page.v1.filters.CategoryFiltersService/GetQuestionnaire" as const;

// GetQuestionnaireOptions returns the available options for a filter attribute.
export const CategoryFiltersService_GetQuestionnaireOptionsLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryFiltersService_GetQuestionnaireOptions
  );
CategoryFiltersService_GetQuestionnaireOptionsLazy.method =
  "aysa_api.services.category_page.v1.filters.CategoryFiltersService/GetQuestionnaireOptions" as const;

// GetQuestionnaireResults returns the applied filters that would result from completing the filter form
// NOTE: This request keeps getting called at every step to ensure the product result count is correct
// and have the applied_filters readily available
export const CategoryFiltersService_GetQuestionnaireResultLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryFiltersService_GetQuestionnaireResult
  );
CategoryFiltersService_GetQuestionnaireResultLazy.method =
  "aysa_api.services.category_page.v1.filters.CategoryFiltersService/GetQuestionnaireResult" as const;

// GetVisualFilters returns visual filter options for eligible categories.
// Visual filters are displayed as image tiles at the top of category pages.
export const CategoryFiltersService_GetVisualFiltersLazy = () =>
  import("./service.grpc").then(
    (m) => m.CategoryFiltersService_GetVisualFilters
  );
CategoryFiltersService_GetVisualFiltersLazy.method =
  "aysa_api.services.category_page.v1.filters.CategoryFiltersService/GetVisualFilters" as const;
